module.exports = __webpack_public_path__ + "img/Logo PNG GERUMIM.721dcbf8.png";